



import React, { useState, useEffect, useRef } from "react";
import "../css-coding/numbers.css";

/* ---------------- COUNT UP COMPONENT ---------------- */

const CountUpAnimation = ({ target, duration = 2000, suffix = "", decimals = 0, trigger }) => {
  const [count, setCount] = useState(0);

  useEffect(() => {
    let start = 0;
    const end = parseFloat(target);
    let startTime = null;

    setCount(0); // reset every time trigger changes

    const animate = (currentTime) => {
      if (!startTime) startTime = currentTime;

      const progress = currentTime - startTime;
      const percentage = Math.min(progress / duration, 1);

      const easeProgress = 1 - Math.pow(1 - percentage, 2);

      const currentVal = start + (end - start) * easeProgress;
      setCount(currentVal);

      if (progress < duration) {
        requestAnimationFrame(animate);
      }
    };

    requestAnimationFrame(animate);

  }, [target, duration, trigger]); // 👈 important

  return (
    <>
      {count.toFixed(decimals)}
      {suffix}
    </>
  );
};

/* ---------------- NUMBER SECTION ---------------- */

const NumberSection = () => {
  const sectionRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);
  const [triggerKey, setTriggerKey] = useState(0);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          setTriggerKey(prev => prev + 1); // 👈 restart animation
        } else {
          setIsVisible(false);
        }
      },
      { threshold: 0.4 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  const stats = [
    { id: 1, value: 40, suffix: "+", label: "Accounts Managed", decimals: 0 },
    { id: 2, value: 100, suffix: "M+", label: "Views Generated", decimals: 1 },
    { id: 3, value: 10000, suffix: "+", label: "Videos Created", decimals: 0 },
  ];

  return (
    <div ref={sectionRef} className="stats-container">
      {stats.map((stat, index) => (
        <div key={stat.id} className="stat-item-wrapper">
          <div className="stat-item">
            <h2 className="stat-number">
              {isVisible && (
                <CountUpAnimation
                  target={stat.value}
                  duration={2000}
                  suffix={stat.suffix}
                  decimals={stat.decimals}
                  trigger={triggerKey} // 👈 important
                />
              )}
            </h2>
            <p className="stat-label">{stat.label}</p>
          </div>

          {index !== stats.length - 1 && (
            <div className="stat-separator"></div>
          )}
        </div>
      ))}
    </div>
  );
};

export default NumberSection;